import { muiTheme } from '@tassat/payments-themes';

const muiStyles = (theme: typeof muiTheme) => ({
    fullWidth: {
        width: '100%',
        alignSelf: 'center' as 'center'
    },
    fieldMappingDivider: { marginBottom: '3rem' },
    flexColumn: {
        display: 'flex',
        flexFlow: 'column nowrap'
    },
    walletSelectWrapper: { padding: '12px 0 0 12px' },
    walletSelect: {
        minWidth: '60%',
        flexGrow: 1,
        paddingRight: '1rem',
        '& > div': { marginBottom: 0 }
    },
    walletOptionSelectWrapper: {
        display: 'flex',
        flexGrow: 1,
        '&:hover': {
            backgroundColor: '#E0EBFD',
            color: '#000'
        },
        '& > div': { borderTop: '1px solid #E4E4E4' },
        '&:first-child > div': { borderTop: 'none' }
    },
    walletOptionSelect: {
        display: 'flex',
        flexFlow: 'row',
        flexGrow: 1,
        alignItems: 'center',
        padding: '10px',
        margin: '0 10px',
        cursor: 'default',
        '&__left': { flexGrow: 1 },
        '&__right': {
            paddingLeft: '1rem',
            borderLeft: '1px solid #E4E4E4'
        }
    },
    walletValueSelect: {
        display: 'flex',
        flexFlow: 'row',
        flexGrow: 1,
        alignItems: 'center',
        color: theme?.app?.applicationColors.enumColors.black || '#000',
        '&__left': { flexGrow: 1 },
        '&__right': {
            paddingLeft: '1rem',
            borderLeft: '1px solid #E4E4E4'
        }
    },
    submitButton: {
        alignSelf: 'center',
        marginTop: '3.5rem',
        marginBottom: '2rem'
    },
    submitError: { alignSelf: 'center' },
    newMappingContainer: {
        paddingTop: '1.25rem',
        width: '100%',
        alignSelf: 'center' as 'center'
    },
    removeMappingContainer: {
        alignSelf: 'center' as 'center',
        paddingBottom: '46px !important'
    },
    apiEnabled: {
        '& label': { alignItems: 'flex-end' },
        '& span': {
            border: `1px solid ${theme?.app?.applicationColors.enumColors.greyLighter || '#CFCFCF'}`,
            borderRadius: '3px'
        }
    },
    roles: {
        '& label': { textAlign: 'center' },
        '& div': { justifyContent: 'center' }
    },
    toggle: {
        '& label': { textAlign: 'center' },
        '& div': { alignSelf: 'center' },
        '& div[role=checkbox]': {
            margin: 'auto' as const,
            marginTop: '.5rem'
        }
    }
});

export default muiStyles;